module.exports = __webpack_public_path__ + "static/shareWater1BG-d958bc97817f00be799be7900ae2d7cd.png";